import { TextField, TextFieldProps } from '@mui/material';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';

interface RhfTextFieldProps {
  label: string;
  name: string;
}

const RhfTextField: FC<RhfTextFieldProps & TextFieldProps> = ({
  label,
  name,
  ...rest
}) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <TextField
      error={!!errors[name]}
      fullWidth
      helperText={errors[name] ? errors[name]?.message : ''}
      label={label}
      variant="outlined"
      {...register(name)}
      {...rest}
    />
  );
};

export default RhfTextField;
